import React, { useEffect, useState, useRef } from "react";
import { getProductGroup } from "../api/HomeApi";
import { TiChevronLeftOutline } from "react-icons/ti";
import { IoMdArrowDropleft } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../layouts/Loading";
import { showError } from "../../../utils/toastHelper";
import { Swiper, SwiperSlide } from "swiper/react";

import {
  TbSquareRoundedMinus,
  TbSquareRoundedPlusFilled,
} from "react-icons/tb";
import { MdOutlinePhoneForwarded } from "react-icons/md";
import { useCart } from "../../../context/CartContext";
import { BsArrowLeftCircle } from "react-icons/bs";
import { FreeMode } from "swiper/modules";
import "swiper/css/free-mode";
import ScrollToTopButton from "../../../components/shared/ScrollToTopButton";
import { getProducts } from "../../products/api/ProductsAPI";
import SortSelect from "../../products/components/SortSelect";
const ProductGroups = (props) => {
  const [productGroups, setProductGroups] = React.useState([]);
  const [groupIDs, setgroupIDs] = React.useState([]);
  const [products, setProducts] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState(null);

  const [page, setPage] = useState(1); // شماره صفحه جاری
  const [lastPage, setLastPage] = useState(1); // شماره آخرین صفحه
  const [loadingBottom, setLoadingBottom] = useState(false); // لودینگ پایین صفحه
  const loaderRef = useRef(null); // رفرنسی برای المنت انتهای صفحه

  const [breadcrumb, setBreadcrumb] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [showProducts, setShowProducts] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const config = window.APP_CONFIG;
  const currencyFormat = Intl.NumberFormat("en-US");
  const { onPlusClick, onMinusClick, getItemCartCount } = useCart();
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        setLoading(true);
        const city = window.localStorage.getItem("_ci") || 0;
        const params = {
          count: props.showAll
            ? 80
            : config.shopping_app_settings.product_group_count,
          special: props.showAll ? 0 : 1,
          city,
          list: 1,
          parent_id: id,
        };
        const data = await getProductGroup(params);
        setProductGroups(data?.data || []);
        setBreadcrumb(data?.data[0]?.breadcrumb);

        if (data?.data) {
          const ids = data.data.map((group) => group.id);
          setgroupIDs(ids);
        }

        if (
          props.showAll &&
          config.shopping_app_settings.show_products_in_groups === "1" &&
          typeof id === "undefined"
        ) {
          setShowProducts(true);
        }
      } catch (err) {
        showError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchGroups();
  }, [id]);

  // تعریف تابع خارج از useEffect برای اینکه بتوانیم جاهای دیگر هم صدا بزنیم
  const fetchProducts = async (pageToLoad = 1, append = false) => {
    try {
      if (!append) setLoading2(true); // اگر صفحه اول است، لودینگ اصلی

      const city = window.localStorage.getItem("_ci") || 0;
      const params = {
        list: 1,
        count: 24,
        page: pageToLoad, // اضافه کردن پارامتر صفحه به API
        city,
        orderBy,
        // group_id: 24,
        multi_group_id: groupIDs,
      };

      const data = await getProducts(params);

      // اگر append true باشد، محصولات جدید را به قبلی‌ها اضافه کن
      // اگر false باشد (بار اول)، محصولات جدید را جایگزین کن
      setProducts((prev) =>
        append ? [...prev, ...(data?.data || [])] : data?.data || [],
      );

      // آپدیت کردن اطلاعات صفحه‌بندی از پاسخ API
      if (data?.meta) {
        setPage(data.meta.current_page);
        setLastPage(data.meta.last_page);
      }
    } catch (err) {
      showError(err);
    } finally {
      setLoading2(false);
      setLoadingBottom(false); // خاموش کردن لودینگ پایین
    }
  };

  // فراخوانی اولیه (وقتی گروه یا مرتب‌سازی عوض می‌شود)
  useEffect(() => {
    if (props.showAll && groupIDs.length > 0 && id !== undefined) {
      setProducts([]); // خالی کردن لیست قبلی
      setPage(1);
      setLastPage(1);
      fetchProducts(1, false); // دریافت صفحه ۱
    }
  }, [id, groupIDs, orderBy]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const first = entries[0];
        // شرط: المنت دیده شود + صفحه فعلی کمتر از آخرین صفحه باشد + در حال لود نباشیم
        if (
          first.isIntersecting &&
          page < lastPage &&
          !loading2 &&
          !loadingBottom
        ) {
          setLoadingBottom(true);
          fetchProducts(page + 1, true); // دریافت صفحه بعدی و الحاق کردن
        }
      },
      { threshold: 1 }, // وقتی ۱۰۰٪ المنت دیده شد
    );

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [page, lastPage, loading2, loadingBottom, groupIDs]); // وابستگی‌ها مهم هستند

  if (loading) return <Loading />;

  return (
    <section className="container  mt-4  rtl px-0   ">
      {!props.showAll && (
        <div className="row mx-1">
          <div className="col-8 home-separator-text ">دسته بندی ها</div>
          <div
            className="col-4 text-start text-small-3 text-secondary-color mt-1"
            onClick={() => {
              navigate(`/categories`);
            }}
          >
            مشاهده همه
            <TiChevronLeftOutline className="mx-1" />
          </div>
        </div>
      )}

      {showProducts ? (
        <div className="row mx-2 pb-3 show-product-part">
          {productGroups.map((group) => {
            if (group.sub_categories_count < 1 && group.product_count < 1) {
              return "";
            }
            return (
              <div
                className="col-12 px-1 text-center product-group product-group-page mb-2 "
                key={group.id}
              >
                <div className="row">
                  <div className="text-end text-big-1 text-muted mb-3 fw-bold col-8">
                    <span>&nbsp;</span>
                    {group.name}
                  </div>
                  <div
                    className="col-4 text-start text-small-3 text-secondary-color mt-2 all-link"
                    onClick={() => {
                      group.sub_categories_count > 0
                        ? window.location.assign(`/categories/${group.id}`)
                        : window.location.assign(`/products/${group.id}`);
                    }}
                  >
                    مشاهده همه
                    <TiChevronLeftOutline className="mx-1" />
                  </div>
                </div>

                <Swiper
                  spaceBetween={1}
                  slidesPerView={3.2}
                  lazy={{
                    loadPrevNext: true, // بارگذاری تصویر قبلی و بعدی
                  }}
                  style={{ paddingBottom: "2px" }}
                  modules={[FreeMode]}
                  freeMode={true}
                  freeModeMomentum={true}
                >
                  {group.sub_categories.map((group) => {
                    return (
                      <SwiperSlide key={group.id} style={{ width: "auto" }}>
                        <div
                          className="px-1 text-center product-group px-1"
                          key={group.id}
                          onClick={() => {
                            group.sub_categories_count > 0
                              ? window.location.assign(
                                  `/categories/${group.id}`,
                                )
                              : window.location.assign(`/products/${group.id}`);
                          }}
                        >
                          <div className="group-image-container">
                            <img
                              src={group.image}
                              alt={group.name}
                              style={{ objectFit: "cover" }}
                            />
                            <div
                              className="title mt-2 px-1"
                              style={{ minHeight: "40px" }}
                            >
                              {group.name.substring(0, 26)}
                              {group.name.length > 26 ? (
                                <span className="text-small-4">...</span>
                              ) : (
                                ""
                              )}
                              {group.sub_categories > 0 && (
                                <span>
                                  <IoMdArrowDropleft />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide style={{ width: "auto" }}>
                    <div
                      className="px-1 text-center product-group px-1 "
                      key={group.id}
                      onClick={() => {
                        group.sub_categories_count > 0
                          ? window.location.assign(`/categories/${group.id}`)
                          : window.location.assign(`/products/${group.id}`);
                      }}
                    >
                      <div className="group-image-container bg-white pt-5">
                        <div className="my-3">
                          <BsArrowLeftCircle className="text-big-5 text-primary-color fw-bold" />
                        </div>
                        <div
                          className="title mt-2 px-1"
                          style={{ minHeight: "70px" }}
                        >
                          مشاهده همه
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="row mx-2 pb-5 my-0">
          <div
            className="d-flex align-items-center overflow-auto flex-nowrap no-scrollbar  text-muted me-0"
            style={{ WebkitOverflowScrolling: "touch" }} // برای اسکرول نرم و روان در iOS
          >
            {breadcrumb.map((item, index) => (
              <div key={item.id} className="d-flex align-items-center pb-2 ">
                <a
                  href={`/categories/${item.id}`}
                  className="text-decoration-none  text-muted text-nowrap px-2"
                  style={{ fontSize: "0.7rem" }}
                >
                  {item.name}
                </a>

                {/* جداکننده که بعد از آخرین آیتم نمایش داده نمی‌شود */}
                {index < breadcrumb.length - 1 && (
                  <span className="text-muted text-small-3 opacity-50">/</span>
                )}
              </div>
            ))}
          </div>
          {productGroups.map((group) => {
            if (group.sub_categories_count < 1 && group.product_count < 1) {
              return "";
            }
            return (
              <div
                className={
                  props.showAll
                    ? "col-4 col-md-2 px-1 text-center product-group"
                    : "col-3 col-md-2 px-1 text-center product-group"
                }
                key={group.id}
                onClick={() => {
                  group.sub_categories_count > 0
                    ? window.location.assign(`/categories/${group.id}`)
                    : window.location.assign(`/products/${group.id}`);
                }}
              >
                <div className="group-image-container">
                  <img src={group.image} alt={group.name} />
                  <div className="title mt-2">
                    {group.name.substring(0, 26)}
                    {group.name.length > 26 ? (
                      <span className="text-small-4">...</span>
                    ) : (
                      ""
                    )}
                    {group.sub_categories > 0 && (
                      <span>
                        <IoMdArrowDropleft />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {props.showAll && products.length < 1 && loading2 && id !== undefined && (
        <div className="row px-0 mx-0">
          <div className="col-12 text-center">
            <div className="text-small-4 mb-4 opacity-50">
              در حال بارگزاری محصولات...
            </div>
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        </div>
      )}

      {products.length > 1 && id !== undefined && (
        <div className="row ms-3 me-2  mb-2">
          <div className="col-6 pb-2  px-0 border-bottom pe-1"></div>
          <div className="col-6 pb-2 px-0 border-bottom text-start ">
            <SortSelect onSetOrderBy={setOrderBy} discountShow={false} />
          </div>
        </div>
      )}
      <div className="row mx-2 " id="group-product">
        {id !== undefined &&
          products?.map((product, index) => {
            return (
              <div className="col-6 col-md-3 px-0 my-2" key={product.id}>
                <div className="row vendor-product m-1">
                  <div
                    className="col-12 text-center mt-3"
                    onClick={() => {
                      navigate(`/product/${product.id}`);
                    }}
                  >
                    {product.vendor_price?.discount_percent > 0 && (
                      <div className="discount-percent">
                        <span className="badge badge-info badge-pill bg-primary-color  text-small-3">
                          {product?.vendor_price?.discount_percent}
                          &nbsp; %
                        </span>
                      </div>
                    )}
                    <div className="clearfix"></div>
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div
                    className="col-12 text-center text-small-1 fw-bold"
                    onClick={() => {
                      navigate(`/product/${product.id}`);
                    }}
                  >
                    {product.name.substring(0, 100)}
                  </div>

                  <div className="col-12 ">
                    {product.vendor_price?.price ? (
                      <div className=" text-start mt-4 mb-2 text-muted fw-bold text-small-1">
                        {product.vendor_price?.discount_percent > 0 ? (
                          <div className="text-decoration-line-through fw-normal text-small-3 opacity-50 ">
                            {currencyFormat.format(product.vendor_price?.price)}
                            &nbsp;
                            {config.currency}
                          </div>
                        ) : (
                          <div className="text-decoration-line-through fw-normal text-small-3 opacity-50">
                            &nbsp;
                          </div>
                        )}

                        <div>
                          {currencyFormat.format(
                            product.vendor_price?.discounted_price,
                          )}
                          &nbsp;
                          <span className="text-small-3 text-muted">
                            {config.currency}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {config.shopping_app_settings.show_plus_minus > 0 && (
                    <div
                      className={
                        getItemCartCount(product.id) > 0
                          ? "add-minus-products text-center mt-0 pt-0 bg-custom rounded"
                          : "add-minus-products text-center mt-0 pt-0"
                      }
                    >
                      {getItemCartCount(product.id) > 0 ? (
                        <span
                          className="add-product-icon text-secondary "
                          onClick={() => {
                            onMinusClick(product.id, product.minimum_purchase);
                          }}
                        >
                          <TbSquareRoundedMinus />
                        </span>
                      ) : (
                        <span>&nbsp;</span>
                      )}

                      {getItemCartCount(product.id) > 0 ? (
                        <span
                          className="px-2"
                          onClick={() => {
                            /* setShowCountBox(true)
                                                             setCountIndex(index)
                                                             setCountId(product.id)
                                                             setCountPrice(product.price)
                                                             setTheCount(getItemCartCount(product.id))*/
                          }}
                        >
                          <input
                            type="tel"
                            className="bg-white"
                            value={getItemCartCount(product.id)}
                            readOnly
                          />
                        </span>
                      ) : (
                        <span>&nbsp;</span>
                      )}

                      {product.inventory > 0 ||
                      config.shopping_app_settings.ignore_inventory > 0 ? (
                        <span className="add-product-icon   ">
                          {product.price > 0 ? (
                            <span
                              onClick={() => {
                                onPlusClick(
                                  product.id,
                                  product.price,
                                  product.inventory,
                                  product.minimum_purchase,
                                  product.maximum_purchase,
                                );
                              }}
                            >
                              <TbSquareRoundedPlusFilled className="text-primary-color" />
                            </span>
                          ) : (
                            <span
                              className="text-primary text-small-3"
                              onClick={() => navigate("/contact")}
                            >
                              <MdOutlinePhoneForwarded className="mx-2" />
                            </span>
                          )}
                        </span>
                      ) : (
                        <span className="text-danger text-small-2">
                          ناموجود
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      <div ref={loaderRef} style={{ height: "20px", margin: "10px 0" }}>
        {loadingBottom && (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        )}
      </div>
      <ScrollToTopButton />
    </section>
  );
};

export default ProductGroups;
